import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sm:flex gap-2 sm:gap-4 mt-4 sm:mt-6 bg-[#1F1F1F] rounded-md p-2 sm:p-4" }
const _hoisted_2 = { class: "sm:space-y-4 space-y-2 mx-auto" }
const _hoisted_3 = { class: "h-72" }
const _hoisted_4 = { class: "flex items-center m-auto w-fit gap-2" }
const _hoisted_5 = { class: "w-full sm:mt-0 mt-6" }
const _hoisted_6 = { class: "flex items-center gap-2 ml-auto rounded-md bg-gray-700 px-4 py-2 max-w-fit mb-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "redirect-label",
  class: "text-white text-ellipsis whitespace-nowrap overflow-hidden"
}, "Redirect Mode", -1)
const _hoisted_8 = { class: "flex gap-2 sm:gap-4 max-w-fit ml-auto" }

import { Button, Form, FormItem, Input, Switch, Tooltip, TreeSelect } from 'ant-design-vue';
import { HttpStatusCode } from 'axios';
import { ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import {
	ArrowLeftOutlined,
	ArrowRightOutlined,
	CloudDownloadOutlined,
	CopyOutlined,
	ReloadOutlined
} from '@ant-design/icons-vue';
import ImageLoading from '@/components/shared/ImageLoading.vue';
import SpinnerLoading from '@/components/shared/SpinnerLoading.vue';
import { Doujin, DoujinDetail } from '@/model/doujin';
import LocalStorageKey from '@/model/key';
import { ActionMode } from '@/model/universal';
import { createDoujin, getImage } from '@/repository/doujin';
import { scrapingDoujin } from '@/util/scraping';


export default /*#__PURE__*/_defineComponent({
  __name: 'DoujinInformation',
  props: {
    doujin: {},
    mode: {}
  },
  setup(__props: any) {

const props = __props;



const store = useStore();
const { push } = useRouter();

const linkStatus = ref('');
const doujin = ref<DoujinDetail>({
	...props.doujin,
	imageURLs: [],
	coverImageURL: props.doujin.imageURL
});
const isLoading = ref(false);
const reload = ref(false);
const imageURL = ref(props.doujin.imageURL);
const isRedirect = ref(localStorage.getItem(LocalStorageKey.DoujinRedirect) === 'on');

watch(isRedirect, () =>
	localStorage.setItem(LocalStorageKey.DoujinRedirect, isRedirect.value ? 'on' : 'off')
);

async function submit() {
	if (linkStatus.value !== 'success' && !reload.value) {
		return;
	}
	isLoading.value = true;
	try {
		switch (props.mode) {
			case ActionMode.Add: {
				if (selectImageIndex.value !== -1) {
					doujin.value.coverImageURL = doujin.value.imageURLs[selectImageIndex.value];
				}
				const response = await createDoujin(doujin.value);
				if (response.status !== HttpStatusCode.Ok) {
					throw Error(`${response?.error?.error}` || '');
				}
				break;
			}
			case ActionMode.Edit: {
				throw Error('implement me!');
			}
		}
		store.dispatch('alert', { type: 'success', message: 'Add doujin successfully!' });
		if (isRedirect.value) {
			await push(`/doujin`);
		} else {
			initialize();
		}
	} catch (error) {
		store.dispatch('alert', {
			type: 'error',
			message: `${error}` || 'something went wrong, please try again!'
		});
	} finally {
		isLoading.value = false;
	}
}

function initialize() {
	doujin.value = { ...props.doujin, imageURLs: [], coverImageURL: props.doujin.imageURL };
	imageURL.value = props.doujin.imageURL;
}

function mapSelect(texts: string[]) {
	return texts.map((text) => {
		return {
			value: text,
			title: text,
			label: text,
			key: text
		};
	});
}

const selectImageIndex = ref(-1);
async function changeImage(event: 'NEXT' | 'BASE' | 'BACK') {
	if (doujin.value.imageURLs.length === 0) {
		return;
	}
	if (event === 'BASE') {
		if (selectImageIndex.value !== -1) {
			selectImageIndex.value = -1;
			await injectImage(doujin.value.coverImageURL);
		}
		return;
	}
	let index = event === 'NEXT' ? selectImageIndex.value + 1 : selectImageIndex.value - 1;
	if (index <= -1) {
		index = doujin.value.imageURLs.length - 1;
	}
	selectImageIndex.value = index % doujin.value.imageURLs.length;
	await injectImage(doujin.value.imageURLs[selectImageIndex.value]);
}

async function injectImage(url: string): Promise<boolean> {
	reload.value = true;
	const image = await getImage(url);
	if (image && image.data) {
		imageURL.value = URL.createObjectURL(image.data);
	}
	reload.value = false;
	return !!image;
}

async function scraping() {
	if (isLoading.value) {
		return;
	}
	isLoading.value = true;
	try {
		const doujinDetail = await scrapingDoujin(doujin.value.link);
		if (doujinDetail.imageURLs.length === 0) {
			throw Error('image not found');
		}
		doujin.value = { ...doujinDetail };
		const success = await injectImage(doujin.value.coverImageURL);
		if (success) {
			linkStatus.value = 'success';
		}
	} catch (error) {
		store.dispatch('alert', {
			type: 'error',
			message: `${error}` || 'something went wrong, please try again!'
		});
		linkStatus.value = '';
	} finally {
		isLoading.value = false;
	}
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SpinnerLoading, { loading: isLoading.value }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(ImageLoading, {
              src: imageURL.value,
              previewable: true,
              reload: reload.value,
              "img-class": "!h-72 !w-72",
              "loading-class": "h-72 w-72 m-auto sm:m-0"
            }, null, 8, ["src", "reload"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(Button), {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (changeImage('BACK')))
            }, {
              icon: _withCtx(() => [
                _createVNode(_unref(ArrowLeftOutlined))
              ]),
              _: 1
            }),
            _createVNode(_unref(Button), {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (changeImage('BASE')))
            }, {
              icon: _withCtx(() => [
                _createVNode(_unref(ReloadOutlined))
              ]),
              _: 1
            }),
            _createVNode(_unref(Button), {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (changeImage('NEXT')))
            }, {
              icon: _withCtx(() => [
                _createVNode(_unref(ArrowRightOutlined))
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(Form), {
            layout: "horizontal",
            model: doujin.value,
            onFinish: _cache[14] || (_cache[14] = ($event: any) => (submit()))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(FormItem), {
                label: "Link",
                name: "link",
                "has-feedback": "",
                "validate-status": linkStatus.value,
                rules: [{ required: true, message: `Please enter doujin link` }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Input).Group, { compact: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Input), {
                        value: doujin.value.link,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((doujin.value.link) = $event)),
                        class: "!w-[calc(100%-2rem)] !text-start",
                        placeholder: `Enter a doujin link`,
                        onChange: _cache[4] || (_cache[4] = () => (linkStatus.value = ''))
                      }, null, 8, ["value"]),
                      _createVNode(_unref(Button), { onClick: scraping }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(CopyOutlined))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["validate-status"]),
              _createVNode(_unref(FormItem), {
                label: "Title",
                name: "title",
                "has-feedback": "",
                rules: [{ required: true, message: `Please enter doujin title` }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Input), {
                    value: doujin.value.title,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((doujin.value.title) = $event)),
                    placeholder: `Enter a doujin title`,
                    disabled: "",
                    class: "bg-white"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_unref(FormItem), {
                label: "Source",
                name: "source",
                "has-feedback": "",
                rules: [{ required: true, message: `Please enter doujin source` }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Input), {
                    value: doujin.value.source,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((doujin.value.source) = $event)),
                    placeholder: `Enter a doujin source`,
                    disabled: "",
                    class: "bg-white"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_unref(FormItem), {
                label: "Code",
                name: "code",
                "has-feedback": "",
                rules: [{ required: true, message: `Please enter doujin code` }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Input), {
                    value: doujin.value.code,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((doujin.value.code) = $event)),
                    placeholder: `Enter a doujin code`,
                    disabled: "",
                    class: "bg-white"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_unref(FormItem), {
                label: "Artists",
                name: "artists",
                "has-feedback": "",
                rules: [{ required: true, message: `Please select doujin artists` }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(TreeSelect), {
                    value: doujin.value.artists,
                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((doujin.value.artists) = $event)),
                    style: {"width":"100%"},
                    "tree-data": mapSelect(doujin.value.artists),
                    "tree-checkable": "",
                    class: "text-start bg-white rounded-md",
                    placeholder: `Please select doujin artists`,
                    "tree-node-filter-prop": "label",
                    disabled: ""
                  }, null, 8, ["value", "tree-data"])
                ]),
                _: 1
              }),
              _createVNode(_unref(FormItem), {
                label: "Characters",
                name: "characters",
                "has-feedback": "",
                rules: [{ required: true, message: `Please select doujin characters` }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(TreeSelect), {
                    value: doujin.value.characters,
                    "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((doujin.value.characters) = $event)),
                    style: {"width":"100%"},
                    "tree-data": mapSelect(doujin.value.characters),
                    "tree-checkable": "",
                    class: "text-start bg-white rounded-md",
                    placeholder: `Please select doujin characters`,
                    "tree-node-filter-prop": "label",
                    disabled: ""
                  }, null, 8, ["value", "tree-data"])
                ]),
                _: 1
              }),
              _createVNode(_unref(FormItem), {
                label: "Tags",
                name: "tags",
                "has-feedback": "",
                rules: [{ required: true, message: `Please select doujin tags` }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(TreeSelect), {
                    value: doujin.value.tags,
                    "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((doujin.value.tags) = $event)),
                    style: {"width":"100%"},
                    "tree-data": mapSelect(doujin.value.tags),
                    "tree-checkable": "",
                    class: "text-start bg-white rounded-md",
                    placeholder: `Please select doujin tags`,
                    "tree-node-filter-prop": "label",
                    disabled: ""
                  }, null, 8, ["value", "tree-data"])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_unref(Switch), {
                  checked: isRedirect.value,
                  "onUpdate:checked": _cache[11] || (_cache[11] = ($event: any) => ((isRedirect).value = $event))
                }, null, 8, ["checked"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_unref(Tooltip), {
                  placement: "top",
                  title: "Bulk Download",
                  class: "sm:block hidden"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Button), {
                      onClick: _cache[12] || (_cache[12] = () => _unref(push)({ name: 'Bulk Create Doujin' })),
                      class: "bg-green-400 border-none hover:bg-green-500 hover:!text-red-600"
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_unref(CloudDownloadOutlined))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Button), {
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (initialize()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Reset")
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Button), {
                  "html-type": "submit",
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Submit")
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}
}

})